module.exports = __webpack_public_path__ + "static/media/arnakia-faba-rebu8ia-petimize.e0ab9b95.jpg";